// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as ReactModal from "react-modal";
import * as PartnerScoreAssetConfig from "../assets/PartnerScoreAssetConfig.bs.js";
import * as PartnerScoreTextContent from "./PartnerScoreTextContent.bs.js";
import * as PartnerScoreVideoContent from "./PartnerScoreVideoContent.bs.js";

function LearnMoreModal(Props) {
  var modal_state = Props.modal_state;
  var title = Props.title;
  var content = Props.content;
  var close_modal = Props.close_modal;
  var isModalOpen = Props.isModalOpen;
  var variant = Props.variant;
  return React.createElement(ReactModal, {
              isOpen: Curry._1(isModalOpen, modal_state),
              onRequestClose: close_modal,
              className: " c-learn-more-details-modal",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: null
            }, React.createElement("div", {
                  className: "c-learn-more-details-modal__close-btn",
                  onClick: (function (param) {
                      return Curry._1(close_modal, undefined);
                    })
                }, React.createElement("img", {
                      className: "c-learn-more-details-modal__close-icon",
                      src: PartnerScoreAssetConfig.close_icon
                    })), React.createElement("div", {
                  className: "modal-wrapper"
                }, React.createElement("div", {
                      className: "modal-header"
                    }, title), Belt_Array.map(content, (function (data) {
                        var url = data.video_url;
                        if (url !== undefined) {
                          return React.createElement(PartnerScoreVideoContent.make, {
                                      title: data.question,
                                      desc: data.answer,
                                      video_url: url,
                                      variant: variant
                                    });
                        } else {
                          return React.createElement(PartnerScoreTextContent.make, {
                                      title: data.question,
                                      desc: data.answer
                                    });
                        }
                      }))));
}

var make = LearnMoreModal;

export {
  make ,
  
}
/* react Not a pure module */
